import { indexData } from '@/mocks/home';

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">专题合集</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">分类整理所有爆料内容，按主题快速找到你想吃的瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300 shrink-0">
                <i className={`${item.icon} text-lg text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <div className="min-w-0">
                <h4 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors mb-1">
                  {item.title}
                </h4>
                <p className="text-xs text-foreground-600 mb-2">{item.description}</p>
                <span className="text-xs text-accent-600 font-medium">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}